import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Popper from '@material-ui/core/Popper';
import Fade from '@material-ui/core/Fade';
import CloseIcon from '@material-ui/icons/Close';
import { Box, Divider, Grid, IconButton, Typography } from '@material-ui/core';
import { APP_PRIMARY } from 'colours';

export default function NotificationPopper(props) {
  const { anchor, close, text, hasMessages } = props;

  const useStyles = makeStyles(theme => ({
    root: {
      zIndex: 999999,
    },
    title: { fontSize: '12px', fontWeight: 600 },
    text: {
      fontSize: '12px',
      fontWeight: hasMessages !== false ? 400 : 600,
      color: hasMessages === null ? '#000000' : APP_PRIMARY,
    },
    container: {
      padding: '30px 20px',
      borderRadius: '5px',
      backgroundColor: '#FFFFFF',
      boxShadow: '-9px 6px 26px -13px rgba(0,0,0,0.73)',
      width: '300px',
    },
    closeIcon: {
      padding: 0,
      color: APP_PRIMARY,
    },
  }));

  const classes = useStyles();
  const open = Boolean(anchor);
  const id = open ? 'transitions-popper' : undefined;

  return (
    <div>
      <Popper
        id={id}
        open={open}
        anchorEl={anchor}
        transition
        className={classes.root}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Box className={classes.container}>
              <Grid container direction="row">
                <Grid item xs={11}>
                  <Typography className={classes.title}>
                    Notifications
                  </Typography>
                  <Box pt={2} pb={1.5}>
                    <Divider />
                  </Box>
                  <Typography className={classes.text}>{text}</Typography>
                  <Box pt={2} pb={1.5}>
                    <Divider />
                  </Box>
                </Grid>
                <Grid item xs={1}>
                  <IconButton
                    aria-label="close"
                    onClick={close}
                    className={classes.closeIcon}
                  >
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </Box>
          </Fade>
        )}
      </Popper>
    </div>
  );
}
